const daysOfTheWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

const rearrangeDate = (dateString) => {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(5, 7);
    const day = dateString.substring(8, 10);

    return `${day}/${month}/${year}`;
};

const datePicker = () => {
    const inputValue = document.querySelector('[data-readonly-input]');

    let inputValeCheck = '';
    let dateIsValid = '';

    if (inputValue) {
        if (inputValue.value.length > 1) {
            inputValeCheck = rearrangeDate(inputValue.value);
            inputValue.nextElementSibling.textContent = 'DD-MM-YYYY';
        }

        dateIsValid = new Date(inputValue.value);
    }

    return {
        showDatepicker: false,
        datepickerValue: inputValeCheck,
        dateFromInputValue: dateIsValid,
        MONTH_NAMES: monthNames,
        DAYS: daysOfTheWeek,
        month: '',
        year: '',
        no_of_days: [],
        blankdays: [],
        days: daysOfTheWeek,

        initDate() {
            const today = new Date();

            function isValidDate(date) {
                return date instanceof Date && !Number.isNaN(Number(date));
            }

            if (isValidDate(this.dateFromInputValue)) {
                this.month = this.dateFromInputValue.getMonth();
                this.year = this.dateFromInputValue.getFullYear();
            } else {
                this.month = today.getMonth();
                this.year = today.getFullYear();
            }

            if (inputValue) {
                inputValue.addEventListener('input', (e) => {
                    this.year = e.target.value.substring(6, 10);
                });
            }
        },

        readonlyCheck(event) {
            if (event.target.hasAttribute('readonly')) {
                event.target.removeAttribute('readonly');
            } else {
                event.target.setAttribute('readonly', true);
            }
        },

        isToday(date) {
            const today = new Date();
            const eachDateInSelectedMonth = new Date(this.year, this.month, date);

            return today.toDateString() === eachDateInSelectedMonth.toDateString();
        },

        getDateValue(date) {
            const selectedDateUi = new Date(this.year, this.month, date);
            const formattedDate = `${`0${selectedDateUi.getDate()}`.slice(-2)}/${`0${
                selectedDateUi.getMonth() + 1
            }`.slice(-2)}/${selectedDateUi.getFullYear()}`;

            this.datepickerValue = formattedDate;

            const selectedDateValue = new Date(this.year, this.month + 1, date);
            this.$refs.date.value = `${selectedDateValue.getFullYear()}-${`0${selectedDateValue.getMonth()}`.slice(
                -2
            )}-${`0${selectedDateValue.getDate()}`.slice(-2)}`;

            this.showDatepicker = false;
        },

        getNoOfDays() {
            const daysInMonth = new Date(this.year, this.month + 1, 0).getDate();

            // find where to start calendar day of week
            const dayOfWeek = new Date(this.year, this.month).getDay();
            const blankdaysArray = [];
            const daysArray = [];

            for (let i = 1; i <= dayOfWeek; i += 1) blankdaysArray.push(i);
            for (let i = 1; i <= daysInMonth; i += 1) daysArray.push(i);

            this.blankdays = blankdaysArray;
            this.no_of_days = daysArray;
        }
    };
};

export default function initdatePicker() {
    window.datePicker = datePicker;
}



// WEBPACK FOOTER //
// ./resources/js/frontend/components/datePicker.js